<template>
    <jw-player
        v-if="isPlayerEnabled"
        @onError="onError($event)"
        @onTime="onTime($event)"
        @onPlay="onPlay($event)"
        @onComplete="onComplete($event)"
        :seek="seek"
        :videoLink="videoLink"/>
</template>

<script>

import JWPlayer from '@/components/common/JWPlayer.vue'

export default {
  components: {
    'jw-player': JWPlayer
  },
  props: {
    videoList: {
      type: Array,
      default: function () {
        return []
      }
    },
    seek: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onError: function (event) {
      this.$emit('onError', event)
    },
    onPause: function () {
    },
    onTime: function (event) {
      this.$emit('onTime', event)
    },
    onPlay: function (event) {
      this.$emit('onPlay', event)
    },
    onComplete: function (event) {
      this.$emit('onComplete', event)
      this.videoList.splice(0, 1)
    }
  },
  computed: {
    isPlayerEnabled: function () {
      return this.videoList.length > 0
    },
    videoLink: function () {
      if (this.videoList && this.videoList.length > 0) {
        return this.videoList[0]
      }
      return ''
    }
  }
}
</script>
